import { atom, DefaultValue, selector } from "recoil";

export const dmsState = atom({
    key: 'dmsManagment',
    default: {
        listMobilityStore: [],
        generalInfo: {
            value:{}
        },
        additionalInfo: {},
        proposalInfo: {},
        eParking: {},
        representativeInfo: {},
        financialInfo: {},
        posInfo: {},
        associationInfo: {},
        documents:[],
        dmsFilterParams: {},
        keylessInfo: {},
        keylessArea: [],
        keylessError: null,
    }
});

export const dmsFilterParams = selector<any>({
    key: 'dmsFilterParams',
    get: ({ get }) => get(dmsState).dmsFilterParams,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            dmsFilterParams: newValue instanceof DefaultValue ? get(dmsState).dmsFilterParams : newValue
        })
    }
});

export const listMobilityStoreState = selector<any>({
    key: 'listMobilityStore',
    get: ({ get }) => get(dmsState).listMobilityStore,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            listMobilityStore: newValue instanceof DefaultValue ? get(dmsState).listMobilityStore : newValue
        })
    }
});

export const generalInfoState = selector<any>({
    key: 'generalInfoStateValue',
    get: ({get}) => get(dmsState).generalInfo.value,
    set: ({get, set}, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            generalInfo: {
                ...get(dmsState).generalInfo,
                value: newValue instanceof DefaultValue ? get(dmsState).generalInfo.value : newValue
            }
        })
    }
});

export const additionalInfoState = selector<any>({
    key: 'additionalInfo',
    get: ({ get }) => get(dmsState).additionalInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            additionalInfo: newValue instanceof DefaultValue ? get(dmsState).additionalInfo : newValue
        })
    }
});

export const proposalInfoState = selector<any>({
    key: 'proposalInfo',
    get: ({ get }) => get(dmsState).proposalInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            proposalInfo: newValue instanceof DefaultValue ? get(dmsState).proposalInfo : newValue
        })
    }
});

export const eParkingState = selector<any>({
    key: 'eParkingInfo',
    get: ({ get }) => get(dmsState).eParking,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            eParking: newValue instanceof DefaultValue ? get(dmsState).eParking : newValue
        })
    }
});

export const representativeInfoState = selector<any>({
    key: 'representativeInfo',
    get: ({ get }) => get(dmsState).representativeInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            representativeInfo: newValue instanceof DefaultValue ? get(dmsState).representativeInfo : newValue
        })
    }
});

export const financialInfoState = selector<any>({
    key: 'financialInfo',
    get: ({ get }) => get(dmsState).financialInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            financialInfo: newValue instanceof DefaultValue ? get(dmsState).financialInfo : newValue
        })
    }
});

export const posInfoState = selector<any>({
    key: 'posInfo',
    get: ({ get }) => get(dmsState).posInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            posInfo: newValue instanceof DefaultValue ? get(dmsState).posInfo : newValue
        })
    }
});

export const associationInfoState = selector<any>({
    key: 'dmsAssociationInfo',
    get: ({ get }) => get(dmsState).associationInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            associationInfo: newValue instanceof DefaultValue ? get(dmsState).associationInfo : newValue
        })
    }
});

export const documentsDmsState = selector<any>({
    key: 'documentsDms',
    get: ({ get }) => get(dmsState).documents,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            documents: newValue instanceof DefaultValue ? get(dmsState).documents : newValue
        })
    }
});

export const keylessInfoState = selector<any>({
    key: 'keylessInfo',
    get: ({ get }) => get(dmsState).keylessInfo,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            keylessInfo: newValue instanceof DefaultValue ? get(dmsState).keylessInfo : newValue
        })
    }
});

export const keylessAreaState = selector<any>({
    key: 'keylessArea',
    get: ({ get }) => get(dmsState).keylessArea,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            keylessArea: newValue instanceof DefaultValue ? get(dmsState).keylessArea : newValue
        })
    }
});

export const keylessErrorState = selector<any>({
    key: 'keylessError',
    get: ({ get }) => get(dmsState).keylessError,
    set: ({ set, get }, newValue) => {
        set(dmsState, {
            ...get(dmsState),
            keylessError: newValue instanceof DefaultValue ? get(dmsState).keylessError : newValue
        })
    }
});

